/**
 * Created by wajidafaneh on 4/19/17.
 */
(function (angular) {
    'use strict';

    angular.module('harriApp')
        .factory('hUserLocation', ['httpHelper', '$q', '$timeout', 'asyncGlobalHandler', 'hEvent', function (httpHelper, $q, $timeout, asyncGlobalHandler, hEvent) {
            var hUserLocation = {};
            var cachedDeviceLocation;

            hUserLocation.location = {notFound: false};

            /**
             * Get user device from browser geolocation (device)
             * @returns {*}
             */
            hUserLocation.getDeviceLocation = function () {
                var defer = $q.defer();

                if (cachedDeviceLocation) {
                    defer.resolve(cachedDeviceLocation);
                    return defer.promise;
                }

                // Check if device geo location is supported by the browser/device
                if (navigator.geolocation) {
                    // get current position
                    navigator.geolocation.getCurrentPosition(function (locationObj) {

                        hEvent.track("location_accept");
                        cachedDeviceLocation = {
                            latitude: parseFloat(locationObj.coords.latitude),
                            longitude: parseFloat(locationObj.coords.longitude)
                        };

                        defer.resolve(cachedDeviceLocation);
                    }, function (error) {
                        defer.reject(error);

                        if (error.code == error.PERMISSION_DENIED) {
                            hEvent.track("location_deny");
                        }
                    });
                }
                else {
                    defer.reject({'code': 'GEOLOCATION_NOT_SUPPORTED'});
                }

                var promise = defer.promise;
                asyncGlobalHandler.watchPromise(promise);

                return promise;
            };

            hUserLocation.getLocation = function () {
                var defer = $q.defer();

                if (hUserLocation.location.notFound === true) {
                    defer.resolve({});

                } else if (hUserLocation.location.notFound === false && hUserLocation.location.latitude) {
                    defer.resolve(hUserLocation.location);

                } else {
                    var cookiesLocation = HStorageManager.get({
                        key: 'user_location',
                        storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE
                    });

                    if (cookiesLocation && cookiesLocation.notFound === false && cookiesLocation.latitude) {
                        hUserLocation.location = cookiesLocation;
                        defer.resolve(hUserLocation.location);

                    } else {
                        UserAPI.getUserLocation()
                            .then(function (data) {

                            if (data && data.lat && data.lon) {

                                hUserLocation.location = data;
                                hUserLocation.location.latitude = parseFloat(hUserLocation.location.lat);
                                hUserLocation.location.longitude = parseFloat(hUserLocation.location.lon);
                                hUserLocation.location.notFound = false;

                                HStorageManager.put({
                                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                                    key: 'user_location',
                                    value: hUserLocation.location,
                                    expiryDays: 7
                                });

                                defer.resolve(hUserLocation.location);

                            } else {
                                hUserLocation.location.notFound = true;
                                defer.resolve({});
                            }
                        }, function () {
                            hUserLocation.location.notFound = true;
                            defer.resolve({});
                        });
                    }
                }

                return defer.promise;
            };

            return hUserLocation;
        }]);
})(angular);
